'use strict';

angular.module('amexReconciliationApp')
  .service('FeatureFlagModel', function FeatureFlagModel(FeatureFlagRepository) {

    var self = this;

    self.retrieveFeatureFlags = function () {
      return FeatureFlagRepository.getFeatureFlags().then(function (response) {
        self.languageFlag = response.languageFlag;
      });
    };

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/FeatureFlagModel.js
// module id = 579
// module chunks = 0